import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import { useReadOneTimezones } from "../../../queries";
import { useDispatch, useSelector } from "react-redux";

import CornerDigitalClock from "../../SharedComponents/Clock/Digital/CornerDigitalClock";
import CornerSimpleClock from "../../SharedComponents/Clock/Simple/CornerSimpleClock";
import CornerClassicClock from "../../SharedComponents/Clock/Classic/CornerClassicClock";
import CornerFlipClock from "../../SharedComponents/Clock/Flip/CornerFlipClock";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const defaultArea = {
    start_margin: 0,
    top_margin: 0,
    width: 35,
    height: 37,
    layout: "landscape-wide"
};


function useWindowDimensions() {
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener("resize", handleResize);
        return () => { window.removeEventListener("resize", handleResize); }
    }, []);

    return dimensions;
}

function CornerClock() {
    const query = useQuery();
    const { width: windowWidth, height: windowHeight } = useWindowDimensions();
    const isLandscape = windowWidth > windowHeight;
    const dispatch = useDispatch();

    const id = query.get("id");
    const access_token = query.get("token");
    const { clockSettings, clockDisplay } = useSelector((state) => state.apps);
    const [loading, setLoading] = useState(true);

    const payload = { media_id: id, token: access_token };
    const [area, setArea] = useState(defaultArea);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const { data, isLoading, isError } = useReadOneTimezones(payload);


    useEffect(() => {
        document.body.classList.add("transparent-body");

        setDimensions({
            width: windowWidth,
            height: windowHeight
        });
        setLoading(false);

        return () => {
            document.body.classList.remove("transparent-body");
        };
    }, [windowWidth, windowHeight]);


    useEffect(() => {
        setArea(data?.media?.clock?.clock_settings?.corner_setting || defaultArea)
    }, [data]);

    if (isLoading && !data) {
        return (
            <div className="h-[100vh] w-[100vw] flex justify-center items-center">
                <Spinner variant="primary" animation="border" size="lg" className="m-3" />
            </div>
        );
    }

    if (isError) {
        return <div className="m-3 text-danger">Error loading clock data.</div>;
    }

    return (
        <div style={{ width: "100vw", height: "100vh" }}>

            <div
                className="corner-container"
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'transparent',
                    overflow: 'hidden',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        left: `${area.start_margin}%`,
                        top: `${area.top_margin}%`,
                        width: `${area.width}%`,
                        height: `${area.height}%`,
                        backgroundColor: 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'move',
                        overflow: 'hidden',
                    }}
                >
                    {clockSettings.clock_type == "DIGITAL" && (<CornerDigitalClock dimensions={dimensions} area={area} timestamp={data.zones[0].timestamp} previewMode={false} />)}
                    {clockSettings.clock_type == "SIMPLE" && (<CornerSimpleClock dimensions={dimensions} area={area} timestamp={data.zones[0].timestamp} previewMode={false} />)}
                    {clockSettings.clock_type == "FLIP" && (<CornerFlipClock dimensions={dimensions} area={area} timestamp={data.zones[0].timestamp} previewMode={false} />)}
                    {clockSettings.clock_type == "ANALOG" && <CornerClassicClock dimensions={dimensions} area={area} timestamp={data.zones[0].timestamp} previewMode={false} />}
                </div>
            </div>
        </div>
    );
}

export default CornerClock;
